import React from 'react'
import { Form, Message } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { HOURS_MIN, HOURS_MAX, clampHour, hourToLocalizedLabel } from '../../utils/kegCollectionFormUtils'

function KegCollectionTimesDropdownGroup(props) {
  const { formValues, onChange, validationErrors, isDisabled } = props
  const { t: translate } = useTranslation()

  const HOUR_OPTIONS = React.useMemo(
    () =>
      Array.from({ length: HOURS_MAX - HOURS_MIN + 1 }, (_, i) => {
        const h = HOURS_MIN + i
        return { key: h, text: hourToLocalizedLabel(h), value: h }
      }),
    []
  )

  return (
    <Form.Group widths="equal" inline={false}>
      <Form.Field required error={!!validationErrors.startHour}>
        <label>{translate('startTime')}</label>
        <Form.Select
          id="kegCollectionFormAvailableStartTime"
          selection
          options={HOUR_OPTIONS}
          value={formValues.startHour}
          onChange={(_, { value }) => onChange('startHour', clampHour(Number(value)))}
          clearable={false}
          fluid
          compact
          disabled={isDisabled}
        />
        {validationErrors.startHour && (
          <Message negative size="small" content={validationErrors.startHour} />
        )}
      </Form.Field>
      <Form.Field
        required
        error={!!validationErrors.endHour || !!validationErrors.collectionWindow}
      >
        <label>{translate('endTime')}</label>
        <Form.Select
          id="kegCollectionFormAvailableEndTime"
          selection
          options={HOUR_OPTIONS}
          value={formValues.endHour}
          onChange={(_, { value }) => onChange('endHour', clampHour(Number(value)))}
          clearable={false}
          fluid
          compact
          disabled={isDisabled}
        />
        {validationErrors.endHour && (
          <Message negative size="small" content={validationErrors.endHour} />
        )}
      </Form.Field>
    </Form.Group>
  )
}

export default React.memo(KegCollectionTimesDropdownGroup)
